import {registerHelpers} from './helpers';
import container from '../../assets/templates/alerts/partials/container.hbs';
import header from '../../assets/templates/alerts/partials/header.hbs';
import defaultCss from '../../assets/templates/alerts/partials/defaultCss.hbs';
import content from '../../assets/templates/alerts/partials/content.hbs';
import footer from '../../assets/templates/alerts/partials/footer.hbs';
import listReviews from '../../assets/templates/alerts/partials/gadgets/reviews/reviewDetails/listReviews.hbs';
import noteLine from '../../assets/templates/alerts/partials/gadgets/common/noteLine.hbs';
import reviewComment from '../../assets/templates/alerts/partials/gadgets/reviews/reviewDetails/reviewComment.hbs';
import review from '../../assets/templates/alerts/partials/gadgets/reviews/reviewDetails/review.hbs';
import reviewSectionHeader from '../../assets/templates/alerts/partials/gadgets/reviews/reviewSectionHeader.hbs';
import reviewSentimentHeader from '../../assets/templates/alerts/partials/gadgets/reviews/reviewDetails/reviewSentimentHeader.hbs';
import pulseSectionHeader from '../../assets/templates/alerts/partials/gadgets/pulse/pulseDetails/pulseSectionHeader.hbs';
import pulseClassHeader from '../../assets/templates/alerts/partials/gadgets/pulse/pulseDetails/pulseClassHeader.hbs';
import listPulseItems from '../../assets/templates/alerts/partials/gadgets/pulse/pulseDetails/listPulseItems.hbs';
import pulseItem from '../../assets/templates/alerts/partials/gadgets/pulse/pulseDetails/pulseItem.hbs';
import socialSectionHeader from '../../assets/templates/alerts/partials/gadgets/social/socialSectionHeader.hbs';
import locationContainer from '../../assets/templates/alerts/partials/locationContainer.hbs';
import mediaSectionHeader from '../../assets/templates/alerts/partials/gadgets/media/mediaDetails/mediaSectionHeader.hbs';
import listMedia from '../../assets/templates/alerts/partials/gadgets/media/mediaDetails/listMedia.hbs';
import mediaItem from '../../assets/templates/alerts/partials/gadgets/media/mediaDetails/mediaItem.hbs';
import listSocial from '../../assets/templates/alerts/partials/gadgets/social/listSocial.hbs';
import reviewResponsesSectionHeader from '../../assets/templates/alerts/partials/gadgets/reviews/reviewResponsesSectionHeader.hbs';
import task from '../../assets/templates/alerts/partials/gadgets/workflow/task.hbs';
import unassignedTasks from '../../assets/templates/alerts/partials/gadgets/workflow/unassignedTasks.hbs';
import unassignedTasksHeader from '../../assets/templates/alerts/partials/gadgets/workflow/unassignedTasksHeader.hbs';
import pendingApprovalTasks from '../../assets/templates/alerts/partials/gadgets/workflow/pendingApprovalTasks.hbs';
import pendingApprovalTasksHeader from '../../assets/templates/alerts/partials/gadgets/workflow/pendingApprovalTasksHeader.hbs';
import overdueTasksHeader from '../../assets/templates/alerts/partials/gadgets/workflow/overdueTasksHeader.hbs';
import overdueTasks from '../../assets/templates/alerts/partials/gadgets/workflow/overdueTasks.hbs';

import yourTasks from '../../assets/templates/alerts/partials/gadgets/workflow/yourTasks.hbs';
import yourTasksHeader from '../../assets/templates/alerts/partials/gadgets/workflow/yourTasksHeader.hbs';
import report from '../../assets/templates/alerts/partials/gadgets/report.hbs';
import dataSource from '../../assets/templates/alerts/partials/gadgets/dataSource.hbs';
import tasksGadget from '../../assets/templates/alerts/partials/gadgets/workflow/tasksGadget.hbs';
import reviewSummary from '../../assets/templates/alerts/partials/gadgets/reviews/reviewSummary.hbs';
import reviewRecap from '../../assets/templates/alerts/partials/gadgets/reviews/reviewRecap.hbs';
import reviewReponses from '../../assets/templates/alerts/partials/gadgets/reviews/reviewReponses.hbs';
import listingSummary from '../../assets/templates/alerts/partials/gadgets/listingSummary.hbs';
import rankingSummary from '../../assets/templates/alerts/partials/gadgets/rankingSummary.hbs';
import pulseSummary from '../../assets/templates/alerts/partials/gadgets/pulse/pulseSummary.hbs';
import pulseSummaryWithSunburst from '../../assets/templates/alerts/partials/gadgets/pulse/pulseSummaryWithSunburst.hbs';
import reviewDetails from '../../assets/templates/alerts/partials/gadgets/reviews/reviewDetails/reviewDetails.hbs';
import pulseDetails from '../../assets/templates/alerts/partials/gadgets/pulse/pulseDetails/pulseDetails.hbs';
import mediaDetails from '../../assets/templates/alerts/partials/gadgets/media/mediaDetails/mediaDetails.hbs';
import social from '../../assets/templates/alerts/partials/gadgets/social/social.hbs';

class TemplateService {

    delimiters;
    Handlebars;

    constructor() {
        this.delimiters = require("handlebars-delimiters");
        this.Handlebars = require("handlebars");
        registerHelpers(this.Handlebars);
    }

    get partials() {
        return [
            {name: "container", template: container},
            {name: "header", template: header},
            {name: "defaultCss", template: defaultCss},
            {name: "content", template: content},
            {name: "footer", template: footer},
            {name: "listReviews", template: listReviews},
            {name: "noteLine", template: noteLine},
            {name: "reviewComment", template: reviewComment},
            {name: "review", template: review},
            {name: "reviewSectionHeader", template: reviewSectionHeader},
            {name: "reviewSentimentHeader", template: reviewSentimentHeader},
            {name: "pulseSectionHeader", template: pulseSectionHeader},
            {name: "pulseClassHeader", template: pulseClassHeader},
            {name: "listPulseItems", template: listPulseItems},
            {name: "pulseItem", template: pulseItem},
            {name: "socialSectionHeader", template: socialSectionHeader},
            {name: "locationContainer", template: locationContainer},
            {name: "mediaSectionHeader", template: mediaSectionHeader},
            {name: "listMedia", template: listMedia},
            {name: "mediaItem", template: mediaItem},
            {name: "listSocial", template: listSocial},
            {name: "reviewResponsesSectionHeader", template: reviewResponsesSectionHeader},
            {name: "task", template: task},
            {name: "unassignedTasks", template: unassignedTasks},
            {name: "unassignedTasksHeader", template: unassignedTasksHeader},
            {name: "overdueTasks", template: overdueTasks},
            {name: "overdueTasksHeader", template: overdueTasksHeader},
            {name: "pendingApprovalTasks", template: pendingApprovalTasks},
            {name: "pendingApprovalTasksHeader", template: pendingApprovalTasksHeader},
            {name: "yourTasks", template: yourTasks},
            {name: "yourTasksHeader", template: yourTasksHeader},
            {name: "report", template: report},
            {name: "dataSource", template: dataSource},
            {name: "tasksGadget", template: tasksGadget},
            {name: "reviewSummary", template: reviewSummary},
            {name: "reviewRecap", template: reviewRecap},
            {name: "reviewReponses", template: reviewReponses},
            {name: "listingSummary", template: listingSummary},
            {name: "rankingSummary", template: rankingSummary},
            {name: "pulseSummary", template: pulseSummary},
            {name: "pulseSummaryWithSunburst", template: pulseSummaryWithSunburst},
            {name: "reviewDetails", template: reviewDetails},
            {name: "pulseDetails", template: pulseDetails},
            {name: "mediaDetails", template: mediaDetails},
            {name: "social", template: social}
        ];
    }

    get defaultCssSection() {
        const defaultCssRegex = /<style type="text\/css">([\s\S]*)<\/style>/g;
        const defaultCSS = defaultCssRegex.exec(defaultCss)[1];
        return `/*BEGIN-DEFAULT-CSS*/ ${defaultCSS} /*END-DEFAULT-CSS*/`;
    }

    get handlebars() {
        return this.Handlebars;
    }

    partialByName(name) {
        return this.partials.filter(p => p.name === name)[0].template;
    }

    delimitBy(delimitors) {
        this.delimiters(this.Handlebars, delimitors);
    }

    registerAllPartials() {
        this.partials.forEach(p => this.Handlebars.registerPartial(p.name,p.template));
    }

}


export default TemplateService;
